import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { QUERIES_KEYS } from 'constant';
import { useDispatch } from 'react-redux';
import { setAllCategories, setIsLoading } from 'store/categorySlice';
import { getCategoryList } from './categoryService';
import { mapValuesById } from '../utils';

function useCategoryListQuery() {
  const dispatch = useDispatch();
  const query = useQuery({
    queryKey: [QUERIES_KEYS.CATEGORIES],
    queryFn: getCategoryList,
    select: mapValuesById, // stays pure
  });

  useEffect(() => {
    dispatch(setIsLoading(query.isFetching));
  }, [query.isFetching, dispatch]);

  useEffect(() => {
    if (query.isSuccess && query.data) {
      dispatch(setAllCategories(query.data));
    }
  }, [query.isSuccess, query.data, dispatch]);

  useEffect(() => {
    if (query.isError) {
      console.error('Error fetching data:', query.error);
    }
  }, [query.isError, query.error]);

  return query;
}

export { useCategoryListQuery };
